//import './App.css';
import { Routes, Route } from "react-router-dom";

import Home from "./views/Home";
import Login from "./views/Login";
import TrainerPortal from "./trainerPortal/TrainerPortal";

import { SideBarContextProvider } from "./context/SideBarContext";

function App() {
  return (
    <SideBarContextProvider>
      <Routes>
        {/* Primary: Affiliator portal */}
        <Route path="/affiliatorportal/*" element={<TrainerPortal />} />
        {/* Legacy aliases (trainerportal, trainer-portal) kept for backward compatibility */}
        <Route path="/trainerportal/*" element={<TrainerPortal />} />
        <Route path="/trainer-portal/*" element={<TrainerPortal />} />
        <Route path="*" element={<Home />} />
        <Route path="/login" element={<Login />} />
      </Routes>
    </SideBarContextProvider>
  );
}

export default App;
